import { Loading } from '../../components/Loading';
import { lazyNamed, loadable } from '../../lazy';

export const PDFPreviewLazy = lazyNamed(
  () => import('./PDFPreview'),
  'PDFPreview'
);

export const PDFPreview = loadable(PDFPreviewLazy, <Loading />);
